import React, { useContext, useEffect, useRef, useState } from "react";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { InputGroup } from "react-bootstrap";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import Account_Created_Modal from "../account-created-modal/Account_Created_Modal";
import Common_Login_Button from "../../../common_components/common-login-button/Common_Login_Button";
import Login_Modal from "../../../common_components/common-login-button/login_modal/Login_Modal";

import "react-phone-input-2/lib/style.css";
import "./Customer_Login.css";
import { useDispatch, useSelector } from "react-redux";
import {
  AllState,
  AllDistrict,
  AllTaluka,
} from "../../../../features/admin/common/Slice";
import { Controller, useForm } from "react-hook-form";
import {
  CreateCustomerSignup,
  sendMobileOtp,
  verifyOtp,
  sendLoginOtp,
  LoginverifyOtp,
  GETCustomer,
  addharSendOtp,
  addharVerifyOtp,
} from "../../../../features/admin/auth/Slice";
import { IDS } from "../../../../utils/IDS";
import { Context } from "../../../../utils/context";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";

const Customer_Login = ({ activeTab }) => {
  const dispatch = useDispatch();
  const mapRef = useRef();
  const mapInstance = useRef(null);
  const searchInputRef = useRef();
  const markerRef = useRef(null);

  const userType = IDS.USER_TYPES[activeTab?.toUpperCase()];

  const { setSignin, isTokenValid, deviceKey, userdata } = useContext(Context);

  const signupStatus = useSelector((state) => state.login?.signupStatus);
  const signupResponse = useSelector((state) => state.login?.signupResponse);
  const navigate = useNavigate();

  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      lat: "",
      long: "",
    },
  });

  const profilePicFile = watch("profile_pic");
  const selectedState = watch("state_id");
  const selectedDistrict = watch("district_id");
  const watchedMobile = watch("mobile_number");

  const states = useSelector((state) => state?.common?.all_state);
  const districts = useSelector((state) => state?.common?.all_district);
  const talukas = useSelector((state) => state?.common?.all_taluka);

  // ====================== States ======================
  const [mobile, setMobile] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const [fullName, setFullName] = useState("");
  const [adhar, setAdhar] = useState("");
  const [loginOtp, setLoginOtp] = useState("");
  const [modalText, setModalText] = useState("");

  // Login OTP States
  const [isOtpSentLogin, setIsOtpSentLogin] = useState(false);
  const [isOtpVerifiedLogin, setIsOtpVerifiedLogin] = useState(false);
  const [loginOtpArray, setLoginOtpArray] = useState(["", "", "", "", "", ""]);
  const [loginOtpError, setLoginOtpError] = useState("");
  const [loginMobileError, setLoginMobileError] = useState("");
  const [timerLogin, setTimerLogin] = useState(60);
  const [isOtpExpiredLogin, setIsOtpExpiredLogin] = useState(false);
  const [isMobileLockedLogin, setIsMobileLockedLogin] = useState(false);
  // console.log(timerLogin, "timerLogintimerLogin");

  // Registration OTP States
  const [isOtpSentRegister, setIsOtpSentRegister] = useState(false);
  const [isOtpVerifiedRegister, setIsOtpVerifiedRegister] = useState(false);
  const [registerOtp, setRegisterOtp] = useState(["", "", "", "", "", ""]);
  const [registerOtpError, setRegisterOtpError] = useState("");
  const [mobileOtpErrorRegister, setMobileOtpErrorRegister] = useState("");
  const [timerRegister, setTimerRegister] = useState(60);
  const [isOtpExpiredRegister, setIsOtpExpiredRegister] = useState(false);
  const [isMobileLockedRegister, setIsMobileLockedRegister] = useState(false);

  const [otpError, setOtpError] = useState("");
  const [mobileOtpError, setMobileOtpError] = useState("");
  const [isOtpExpired, setIsOtpExpired] = useState(false);
  const [isMobileLocked, setIsMobileLocked] = useState(false);
  const [loadingSendOtp, setLoadingSendOtp] = useState(false);
  const [loadingVerifyOtp, setLoadingVerifyOtp] = useState(false);
  const [loadingLogin, setLoadingLogin] = useState(false);
  const [loadingRegister, setLoadingRegister] = useState(false);
  const [loadingSendRegisterOtp, setLoadingSendRegisterOtp] = useState(false);
  const [loadingVerifyRegisterOtp, setLoadingVerifyRegisterOtp] = useState(
    false,
  );

  const [isAadharOtpSent, setIsAadharOtpSent] = useState(false);
  const [isAadharOtpVerified, setIsAadharOtpVerified] = useState(false);
  const [aadharOtp, setAadharOtp] = useState(["", "", "", "", "", ""]);
  const [aadharOtpError, setAadharOtpError] = useState("");
  const [aadharOtpTimer, setAadharOtpTimer] = useState(600); // 10 minutes
  const [isAadharOtpExpired, setIsAadharOtpExpired] = useState(false);
  const [loadingAadharSendOtp, setLoadingAadharSendOtp] = useState(false);
  const [loadingAadharVerifyOtp, setLoadingAadharVerifyOtp] = useState(false);
  const [isAadharLocked, setIsAadharLocked] = useState(false);

  const selectStyles = {
    control: (base) => ({
      ...base,
      height: "45px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      boxShadow: "none",
      "&:hover": { border: "1px solid #aaa" },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  useEffect(() => {
    dispatch(AllState());
    dispatch(AllDistrict());
    dispatch(AllTaluka());
  }, [dispatch]);

  useEffect(() => {
    if (selectedState?.value) {
      dispatch(AllDistrict({ state_id: selectedState.value }));
    } else {
      setValue("district_id", null);
    }
  }, [selectedState]);

  useEffect(() => {
    if (selectedDistrict?.value) {
      dispatch(AllTaluka({ district_id: selectedDistrict.value }));
    } else {
      setValue("taluqa_id", null);
    }
  }, [selectedDistrict, dispatch, setValue]);

  const handleStateChange = async (selectedOption) => {
    setValue("state_id", selectedOption, { shouldValidate: true });
    setValue("district_id", null);
    setValue("taluqa_id", null);
    dispatch(AllDistrict({ state_id: selectedOption.value }));
  };

  // Map
  useEffect(() => {
    if (isRegistering) {
      setTimeout(loadMap, 300);
    }
  }, [isRegistering]);

  const loadMap = () => {
    if (window.google && window.google.maps) {
      initMap();
    }
  };

  const initMap = () => {
    const defaultPosition = { lat: 18.5204, lng: 73.8567 };
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const currentPosition = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          loadMapWithPosition(currentPosition);
          setValue("lat", position.coords.latitude.toString());
          setValue("long", position.coords.longitude.toString());
        },
        (error) => {
          loadMapWithPosition(defaultPosition);
          setValue("lat", defaultPosition.lat.toString());
          setValue("long", defaultPosition.lng.toString());
        },
      );
    } else {
      loadMapWithPosition(defaultPosition);
      setValue("lat", defaultPosition.lat.toString());
      setValue("long", defaultPosition.lng.toString());
    }
  };

  const loadMapWithPosition = (position) => {
    if (!window.google || !mapRef.current) return;

    mapInstance.current = new window.google.maps.Map(mapRef.current, {
      center: position,
      zoom: 15,
    });

    markerRef.current = new window.google.maps.Marker({
      position: position,
      map: mapInstance.current,
      draggable: true,
    });

    setValue("lat", position.lat.toString());
    setValue("long", position.lng.toString());

    markerRef.current.addListener("dragend", (e) => {
      setValue("lat", e.latLng.lat().toString());
      setValue("long", e.latLng.lng().toString());
    });

    mapInstance.current.addListener("click", (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      markerRef.current.setPosition({ lat, lng });
      setValue("lat", lat.toString());
      setValue("long", lng.toString());
    });

    initAutocomplete();
  };

  const initAutocomplete = () => {
    if (!searchInputRef.current || !window.google || !mapInstance.current)
      return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInputRef.current,
    );
    autocomplete.bindTo("bounds", mapInstance.current);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) return;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const position = { lat, lng };

      mapInstance.current.setCenter(position);
      mapInstance.current.setZoom(15);
      markerRef.current.setPosition(position);

      setValue("lat", lat.toString());
      setValue("long", lng.toString());
      searchInputRef.current.value = place.formatted_address;
    });
  };

  // ====================== REGISTRATION OTP FLOW ======================
  const handleSendRegisterOtp = async () => {
    if (loadingSendRegisterOtp) return;
    setMobileOtpErrorRegister("");
    const mobileNumber = watchedMobile;

    if (!mobileNumber || mobileNumber.length !== 10) {
      setMobileOtpErrorRegister("Enter valid 10 digit mobile number");
      return;
    }

    setLoadingSendRegisterOtp(true);

    try {
      const res = await dispatch(
        sendMobileOtp({ mobile_number: mobileNumber, type: userType }),
      );

      if (res?.meta?.requestStatus === "fulfilled") {
        setIsOtpSentRegister(true);
        setIsOtpVerifiedRegister(false);
        setRegisterOtp(["", "", "", "", "", ""]);
        setTimerRegister(60);
        setIsOtpExpiredRegister(false);
        setIsMobileLockedRegister(true);
      } else {
        setMobileOtpErrorRegister(
          res?.payload?.message || "Failed to send OTP",
        );
      }
    } catch (err) {
      setMobileOtpErrorRegister("Something went wrong");
    } finally {
      setLoadingSendRegisterOtp(false); // ✅ stop loader
    }
  };

  const handleVerifyRegisterOtp = async () => {
    if (loadingVerifyRegisterOtp) return;
    // setLoadingVerifyRegisterOtp(true);
    const enteredOtp = registerOtp.join("");
    if (enteredOtp.length !== 6) {
      setRegisterOtpError("Please enter 6 digit OTP");
      return;
    }
    setLoadingVerifyRegisterOtp(true);

    try {
      const res = await dispatch(
        verifyOtp({
          mobile_number: watchedMobile,
          otp: enteredOtp,
          type: userType,
        }),
      );

      if (res?.payload?.success) {
        setIsOtpVerifiedRegister(true);
        setRegisterOtpError("");
        setIsMobileLockedRegister(true);
      } else {
        setRegisterOtpError(res?.payload?.message || "Invalid OTP");
      }
    } catch (error) {
      setRegisterOtpError("Something went wrong");
    } finally {
      setLoadingVerifyRegisterOtp(false); // ✅ stop loader
    }
  };

  const handleSendLoginOtp = async () => {
    if (loadingSendOtp) return; // 🚫 prevent double click
    setLoginMobileError("");

    if (!mobile || mobile.length !== 10) {
      setLoginMobileError("Enter valid mobile number");
      return;
    }

    setLoadingSendOtp(true); // ✅ start loader

    try {
      const res = await dispatch(
        sendLoginOtp({ mobile_number: mobile, type: userType }),
      );

      if (res?.meta?.requestStatus === "fulfilled") {
        setIsOtpSentLogin(true);
        setLoginOtpArray(["", "", "", "", "", ""]);
        setTimerLogin(60);
        setIsOtpExpiredLogin(false);

        setIsMobileLockedLogin(true); // ✅ ADD THIS LINE
      } else {
        setLoginMobileError(res?.payload?.message);
      }
    } finally {
      setLoadingSendOtp(false); // ✅ stop loader
    }
  };

  const handleLoginVerifyOtp = async () => {
    if (loadingVerifyOtp) return;
    setLoginOtpError("");

    // setLoadingVerifyOtp(true);
    if (isOtpExpiredLogin) {
      setLoginOtpError("OTP expired. Please resend.");
      return;
    }
    // if (isOtpExpiredLogin) {
    //   alert("Expired OTP");
    //   return;
    // }

    const enteredOtp = loginOtpArray.join("");
    if (enteredOtp.length !== 6) {
      setLoginOtpError("Please enter 6 digit OTP");
      return;
    }

    setLoadingVerifyOtp(true);

    // ✅ Get current location
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const lat = position.coords.latitude;
          const long = position.coords.longitude;

          try {
            const res = await dispatch(
              LoginverifyOtp({
                mobile_number: mobile,
                otp: enteredOtp,
                type: userType,
                device_key: deviceKey,
                lat: lat, // ✅ added
                long: long, // ✅ added
              }),
            );

            if (res?.payload?.success) {
              setIsOtpVerifiedLogin(true);
              setLoginOtpError("");
              setIsMobileLockedLogin(true);
            } else {
              setLoginOtpError(res?.payload?.message || "Invalid OTP");
            }
          } catch (error) {
            setLoginOtpError("Something went wrong");
          } finally {
            setLoadingVerifyOtp(false);
          }
        },
        async (error) => {
          console.log("Location error:", error);

          // ❗ fallback if location denied
          try {
            const res = await dispatch(
              LoginverifyOtp({
                mobile_number: mobile,
                otp: enteredOtp,
                type: userType,
                device_key: deviceKey,
                lat: null,
                long: null,
              }),
            );

            if (res?.payload?.success) {
              setIsOtpVerifiedLogin(true);
              setLoginOtpError("");
              setIsMobileLockedLogin(true);
            } else {
              setLoginOtpError(res?.payload?.message || "Invalid OTP");
            }
          } catch (error) {
            setLoginOtpError("Something went wrong");
          } finally {
            setLoadingVerifyOtp(false); // ✅ MUST ADD
          }
        },
      );
    } else {
      alert("Geolocation is not supported by this browser");
    }
  };

  // const handleSendAadharOtp = async () => {
  //   const aadharNo = getValues("adhar_no");

  //   if (!aadharNo || aadharNo.length !== 12) {
  //     setAadharOtpError("Enter valid 12 digit Aadhaar Number");
  //     return;
  //   }

  //   setLoadingAadharSendOtp(true);
  //   setAadharOtpError("");

  //   try {
  //     const res = await dispatch(
  //       addharSendOtp({
  //         aadhaar_number: aadharNo,
  //       }),
  //     );
  //     if (res?.payload?.success) {
  //       const newReqId = res?.payload?.data?.response?.ref_id;

  //       if (newReqId) {
  //         Cookies.set("aadhaar_ref_id", newReqId, { expires: 1 });
  //         console.log("New Req ID:", newReqId);
  //       }

  //       setIsAadharOtpSent(true);
  //       setIsAadharOtpVerified(false);
  //       setAadharOtp(["", "", "", "", "", ""]);
  //       setAadharOtpTimer(600);
  //       setIsAadharOtpExpired(false);
  //       setIsAadharLocked(true);
  //     } else {
  //       let errorMessage = "Failed to send Aadhaar OTP";

  //       if (typeof res?.payload?.message === "string") {
  //         errorMessage = res.payload.message;
  //       } else if (
  //         typeof res?.payload?.message === "object" &&
  //         res?.payload?.message?.aadhaar_number?.length
  //       ) {
  //         errorMessage = res.payload.message.aadhaar_number[0];
  //       } else if (res?.payload?.data?.msg) {
  //         errorMessage = res.payload.data.msg;
  //       }

  //       setAadharOtpError(errorMessage);
  //     }
  //   } catch (error) {
  //     setAadharOtpError("Something went wrong");
  //   } finally {
  //     setLoadingAadharSendOtp(false);
  //   }
  // };

  //below code was after client changes for showing the please try after some time showing error  and above code was showing all the error when success false
  const handleSendAadharOtp = async () => {
    const aadharNo = getValues("adhar_no");

    if (!aadharNo || aadharNo.length !== 12) {
      setAadharOtpError("Enter valid 12 digit Aadhaar Number");
      return;
    }

    setLoadingAadharSendOtp(true);
    setAadharOtpError("");

    try {
      const res = await dispatch(
        addharSendOtp({
          aadhaar_number: aadharNo,
        }),
      );

      if (res?.payload?.success) {
        const newReqId = res?.payload?.data?.response?.ref_id;

        if (newReqId) {
          Cookies.set("aadhaar_ref_id", newReqId, { expires: 1 });
        }

        setIsAadharOtpSent(true);
        setIsAadharOtpVerified(false);
        setAadharOtp(["", "", "", "", "", ""]);
        setAadharOtpTimer(600); // 10 minutes
        setIsAadharOtpExpired(false);
        setIsAadharLocked(true);
      } else {
        setAadharOtpError("Please try after sometime");
      }
    } catch (error) {
      setAadharOtpError("Please try after sometime");
    } finally {
      setLoadingAadharSendOtp(false);
    }
  };

  const handleVerifyAadharOtp = async () => {
    const enteredOtp = aadharOtp.join("");

    if (enteredOtp.length !== 6) {
      setAadharOtpError("Please enter 6 digit OTP");
      return;
    }

    const refId = Cookies.get("aadhaar_ref_id");

    setLoadingAadharVerifyOtp(true);

    try {
      const res = await dispatch(
        addharVerifyOtp({
          aadhaar_number: getValues("adhar_no"),
          otp: enteredOtp,
          req_id: refId,
        }),
      );

      if (res?.payload?.success) {
        setIsAadharOtpVerified(true);
        setAadharOtpError("");

        Cookies.remove("aadhaar_ref_id");
      } else {
        let errorMessage = "Invalid OTP";

        if (typeof res?.payload?.message === "string") {
          errorMessage = res.payload.message;
        } else if (typeof res?.payload?.message === "object") {
          const messageObj = res.payload.message;

          if (messageObj.req_id?.length) {
            errorMessage = messageObj.req_id[0];
          } else if (messageObj.otp?.length) {
            errorMessage = messageObj.otp[0];
          } else if (messageObj.aadhaar_number?.length) {
            errorMessage = messageObj.aadhaar_number[0];
          } else {
            errorMessage = Object.values(messageObj).flat()[0];
          }
        } else if (typeof res?.payload?.data === "string") {
          errorMessage = res.payload.data;
        }

        setAadharOtpError(errorMessage);
      }
    } catch (error) {
      setAadharOtpError(
        error?.response?.data?.message || "Something went wrong",
      );
    } finally {
      setLoadingAadharVerifyOtp(false);
    }
  };

  useEffect(() => {
    let interval;

    if (isAadharOtpSent && !isAadharOtpVerified && aadharOtpTimer > 0) {
      interval = setInterval(() => {
        setAadharOtpTimer((prev) => prev - 1);
      }, 1000);
    }

    if (aadharOtpTimer === 0 && isAadharOtpSent && !isAadharOtpVerified) {
      setIsAadharOtpExpired(true);
    }

    return () => clearInterval(interval);
  }, [isAadharOtpSent, isAadharOtpVerified, aadharOtpTimer]);

  const handleAadharOtpChange = (value, index) => {
    if (!/^\d?$/.test(value)) return;

    const newOtp = [...aadharOtp];
    newOtp[index] = value;

    setAadharOtp(newOtp);

    if (value && index < 5) {
      document.getElementById(`otp-aadhar-${index + 1}`)?.focus();
    }
  };

  const handleAadharOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !aadharOtp[index] && index > 0) {
      document.getElementById(`otp-aadhar-${index - 1}`)?.focus();
    }
  };

  // ====================== MAIN SUBMIT ======================
  const onSubmit = async (data) => {
    if (!isRegistering) {
      // if (loadingLogin) return;
      // setLoadingLogin(true);
      if (!mobile || mobile.length !== 10) {
        setLoginMobileError("Please enter contact number");
        return;
      }

      if (!isOtpSentLogin) {
        setLoginOtpError("Please send OTP first");
        return;
      }
      if (!isOtpVerifiedLogin) {
        setLoginOtpError("Please verify OTP first");
        return;
      }
      // ✅ START LOADER AFTER VALIDATION
      setLoadingLogin(true);

      try {
        await isTokenValid();
        navigate("/");
      } finally {
        setLoadingLogin(false);
      }

      return;
    }

    // SIGNUP FLOW
    if (!isOtpSentRegister) {
      setRegisterOtpError("Please send OTP first");
      return;
    }

    if (!isOtpVerifiedRegister) {
      setRegisterOtpError("Please verify OTP first");
      return;
    }

    if (!isAadharOtpSent) {
      setAadharOtpError("Please send Aadhaar OTP first");
      return;
    }

    if (!isAadharOtpVerified) {
      setAadharOtpError("Please verify Aadhaar OTP first");
      return;
    }

    setLoadingRegister(true);

    try {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("mobile_number", data.mobile_number);
      formData.append("email", data.email);
      formData.append("password", data.password);
      formData.append("adhar_no", data.adhar_no);
      formData.append("state_id", data.state_id.value);
      formData.append("district_id", data.district_id.value);
      formData.append("taluqa_id", data.taluqa_id.value);
      formData.append("area", data.area);
      formData.append("lat", data.lat);
      formData.append("long", data.long);

      if (data.profile_pic?.[0]) {
        formData.append("profile_pic", data.profile_pic[0]);
      }

      formData.append("device_key", deviceKey);

      const result = await dispatch(CreateCustomerSignup(formData)).unwrap();

      if (result?.success) {
        setModalText("Sign Up Successfully!");
        setShowAccountModal(true);

        setTimeout(() => {
          setShowAccountModal(false);
          setIsRegistering(false);
          reset();
          setRegisterOtp(["", "", "", "", "", ""]);
          setIsOtpSentRegister(false);
          setIsOtpVerifiedRegister(false);
          setIsMobileLockedRegister(false);
          setIsOtpExpiredRegister(false);
          setMobileOtpErrorRegister("");
        }, 2000);
      }
    } catch (err) {
      alert("Signup failed. Please try again.");
    } finally {
      setLoadingRegister(false);
    }
  };

  // Timer for Registration
  useEffect(() => {
    let interval;
    if (isOtpSentRegister && timerRegister > 0 && !isOtpVerifiedRegister) {
      interval = setInterval(() => setTimerRegister((prev) => prev - 1), 1000);
    }

    if (timerRegister === 0 && isOtpSentRegister && !isOtpVerifiedRegister) {
      setIsOtpExpiredRegister(true);
    }
    return () => clearInterval(interval);
  }, [isOtpSentRegister, timerRegister, isOtpVerifiedRegister]);

  // Timer for Login
  useEffect(() => {
    let interval;
    if (isOtpSentLogin && timerLogin > 0 && !isOtpVerifiedLogin) {
      interval = setInterval(() => setTimerLogin((prev) => prev - 1), 1000);
    }
    if (timerLogin === 0 && isOtpSentLogin && !isOtpVerifiedLogin) {
      setIsOtpExpiredLogin(true);
    }
    return () => clearInterval(interval);
  }, [isOtpSentLogin, timerLogin, isOtpVerifiedLogin]);

  const handleOtpChange = (value, index, isLogin = false) => {
    if (!/^\d?$/.test(value)) return;
    const newOtp = isLogin ? [...loginOtpArray] : [...registerOtp];
    newOtp[index] = value;
    if (isLogin) setLoginOtpArray(newOtp);
    else setRegisterOtp(newOtp);
    if (value && index < 5) {
      document
        .getElementById(`otp-${isLogin ? "login" : "register"}-${index + 1}`)
        ?.focus();
    }
  };

  const handleOtpKeyDown = (e, index, isLogin = false) => {
    if (
      e.key === "Backspace" &&
      !(isLogin ? loginOtpArray[index] : registerOtp[index]) &&
      index > 0
    ) {
      document
        .getElementById(`otp-${isLogin ? "login" : "register"}-${index - 1}`)
        ?.focus();
    }
  };

  const formatTimer = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return (
    <div className="customer-card-container">
      <Form className="customer-form-body" onSubmit={handleSubmit(onSubmit)}>
        <div className="customer-header-row">
          <div className="customer-title-stack">
            <span className="customer-main-title">
              {isRegistering ? "Register as" : "Login as"} {activeTab}
            </span>
            <p className="customer-subtitle">to Nova Prime</p>
          </div>
          <img
            src="/assets/header/nova-prime-logo.png"
            alt="Logo"
            className="customer-brand-logo"
          />
        </div>

        {!isRegistering ? (
          // ==================== LOGIN SECTION ====================
          <div className="login-fields-container">
            <div className="customer-input-group">
              <label>Mobile Number*</label>
              <div className="phone-wrapper">
                <span className="country-code">+91</span>
                <Form.Control
                  type="tel"
                  placeholder="Enter mobile number"
                  className="phone-input"
                  value={mobile}
                  maxLength={10}
                  disabled={isMobileLockedLogin}
                  // onChange={(e) => {
                  //   setMobile(e.target.value.replace(/\D/g, ""));
                  //   setLoginMobileError("");
                  // }}
                  onChange={(e) => {
                    setMobile(e.target.value.replace(/\D/g, ""));
                    setLoginMobileError("");
                    setLoginOtpError(""); // ✅ FIX
                  }}
                />
              </div>
              {loginMobileError && (
                <div className="text-danger mt-1">{loginMobileError}</div>
              )}
            </div>

            {isOtpSentLogin && (
              <button
                type="button"
                className="btn btn-link p-0 mt-1"
                onClick={() => {
                  setIsMobileLockedLogin(false);
                  setIsOtpSentLogin(false);
                  setIsOtpVerifiedLogin(false);
                  setLoginOtpArray(["", "", "", "", "", ""]);
                  setTimerLogin(30);
                  setIsOtpExpiredLogin(false);
                  setLoginOtpError("");
                  setLoginMobileError("");
                }}
              >
                Change Number
              </button>
            )}

            {!isOtpSentLogin && !isMobileLockedLogin && (
              <button
                type="button"
                className="btn btn-outline-primary w-100 mt-2"
                disabled={mobile.length !== 10 || loadingSendOtp}
                onClick={handleSendLoginOtp}
              >
                {loadingSendOtp ? "Sending..." : "Send OTP"}
              </button>
            )}

            {loginOtpError && !isOtpVerifiedLogin && (
              <div className="text-danger mt-2 text-center">
                {loginOtpError}
              </div>
            )}

            {isOtpSentLogin && !isOtpVerifiedLogin && !isOtpExpiredLogin && (
              <div className="customer-otp-dotted-box">
                <label className="customer-otp-label">Enter OTP</label>

                <div className="customer-otp-slots">
                  {loginOtpArray.map((digit, index) => (
                    <div key={index} className="customer-otp-slot">
                      <input
                        id={`otp-login-${index}`}
                        // type="text"
                        maxLength="1"
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={digit}
                        className="customer-otp-input"
                        // onChange={(e) =>
                        //   handleOtpChange(e.target.value, index, true)
                        // }
                        onChange={(e) => {
                          handleOtpChange(e.target.value, index, true);
                          setLoginOtpError(""); // ✅ CLEAR ERROR
                        }}
                        onKeyDown={(e) => handleOtpKeyDown(e, index, true)}
                      />
                      <hr className="customer-otp-line" />
                    </div>
                  ))}
                </div>

                <button
                  type="button"
                  className="btn btn-success w-100 mt-3"
                  onClick={handleLoginVerifyOtp}
                  disabled={loadingVerifyOtp}
                >
                  {loadingVerifyOtp ? "Verifying..." : "Verify OTP"}
                </button>

                <div className="text-center mt-2">
                  {/* <small className="text-muted">
                    Resend OTP in {timerLogin}s
                  </small> */}
                  <small className="text-muted" key={timerLogin}>
                    Resend OTP in {timerLogin}s
                  </small>
                </div>
              </div>
            )}

            {isOtpExpiredLogin && !isOtpVerifiedLogin && (
              <button
                type="button"
                className="btn btn-outline-primary w-100 mt-2"
                onClick={handleSendLoginOtp}
              >
                Resend OTP
              </button>
            )}

            {/* ==================== NEW MESSAGE AFTER OTP VERIFIED IN LOGIN ==================== */}
            {isOtpVerifiedLogin && (
              <div className="alert alert-success text-center mt-3">
                OTP Verified Successfully! Click on <strong>Login</strong> to
                continue.
              </div>
            )}
          </div>
        ) : (
          // ==================== FULL REGISTRATION SECTION ====================
          <div className="scroll-form-body">
            <div className="register-fields-container">
              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  {...register("name", {
                    required: "Full Name is required",
                    pattern: {
                      value: /^[A-Za-z\s]+$/,
                      message: "Only alphabets are allowed",
                    },
                  })}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                    e.target.value = value;
                  }}
                  className={classNames({ "is-invalid": errors?.name })}
                />
                {errors?.name && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.name.message}
                  </span>
                )}
                <label>Full Name*</label>
              </div>

              <div className="customer-input-group">
                <Form.Control
                  type="tel"
                  placeholder=" "
                  disabled={isMobileLockedRegister}
                  {...register("mobile_number", {
                    required: "Mobile number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Enter valid 10 digit mobile number",
                    },
                  })}
                  maxLength={10}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setValue("mobile_number", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  }}
                  className={classNames({
                    "is-invalid": errors?.mobile_number,
                  })}
                />
                <label className="static-label">Mobile Number*</label>

                {isOtpSentRegister && (
                  <button
                    type="button"
                    className="btn btn-link p-0 mt-1"
                    onClick={() => {
                      // ✅ Unlock mobile input
                      setIsMobileLockedRegister(false);
                      // ✅ Reset OTP flow
                      setIsOtpSentRegister(false);
                      setIsOtpVerifiedRegister(false);
                      // ✅ Clear OTP fields
                      setRegisterOtp(["", "", "", "", "", ""]);
                      // ✅ Reset timer properly (same as login)
                      setTimerRegister(60);
                      // ✅ Reset expiry
                      setIsOtpExpiredRegister(false);
                      // ✅ Clear errors (IMPORTANT 🔥)
                      setRegisterOtpError("");
                      setMobileOtpErrorRegister("");
                    }}
                  >
                    Change Number
                  </button>
                )}

                {errors?.mobile_number && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.mobile_number.message}
                  </span>
                )}
              </div>

              {!isOtpSentRegister && !isOtpVerifiedRegister && (
                <button
                  type="button"
                  className="btn btn-outline-primary w-100 mt-2"
                  disabled={
                    !watchedMobile ||
                    watchedMobile.length !== 10 ||
                    loadingSendRegisterOtp
                  }
                  onClick={handleSendRegisterOtp}
                >
                  {loadingSendRegisterOtp ? "Sending..." : "Send OTP"}
                </button>
              )}
              {/* {registerOtpError && (
                <div className="text-danger text-center mt-2">
                  {registerOtpError}
                </div>
              )} */}

              {mobileOtpErrorRegister && (
                <div className="text-danger mt-2">{mobileOtpErrorRegister}</div>
              )}

              {isOtpSentRegister &&
                !isOtpExpiredRegister &&
                !isOtpVerifiedRegister && (
                  <div className="customer-otp-dotted-box">
                    <label className="customer-otp-label">Enter OTP</label>
                    <div className="customer-otp-slots">
                      {registerOtp.map((digit, index) => (
                        <div key={index} className="customer-otp-slot">
                          <input
                            id={`otp-register-${index}`}
                            type="tel"
                            inputMode="numeric"
                            maxLength="1"
                            value={digit}
                            className="customer-otp-input"
                            onChange={(e) => {
                              handleOtpChange(e.target.value, index, false);
                              setRegisterOtpError("");
                            }}
                            onKeyDown={(e) => handleOtpKeyDown(e, index, false)}
                          />
                          <hr className="customer-otp-line" />
                        </div>
                      ))}
                    </div>

                    {registerOtpError && (
                      <div className="text-danger text-center mt-2">
                        {registerOtpError}
                      </div>
                    )}

                    {/* <button
                      type="button"
                      className="btn btn-success w-100 mt-3"
                      disabled={isOtpVerifiedRegister}
                      onClick={handleVerifyRegisterOtp}
                    >
                      {isOtpVerifiedRegister ? "OTP Verified ✅" : "Verify OTP"}
                    </button> */}
                    <button
                      type="button"
                      className="btn btn-success w-100 mt-3"
                      disabled={
                        isOtpVerifiedRegister || loadingVerifyRegisterOtp
                      }
                      onClick={handleVerifyRegisterOtp}
                    >
                      {loadingVerifyRegisterOtp
                        ? "Verifying..."
                        : isOtpVerifiedRegister
                        ? "OTP Verified ✅"
                        : "Verify OTP"}
                    </button>

                    {!isOtpVerifiedRegister && (
                      <div className="text-center mt-2">
                        {isOtpExpiredRegister ? (
                          <button
                            type="button"
                            className="btn btn-link p-0"
                            onClick={handleSendRegisterOtp}
                          >
                            Resend OTP
                          </button>
                        ) : (
                          // <small className="text-muted">
                          //   Resend OTP in {timerRegister}s
                          // </small>
                          <small className="text-muted" key={timerRegister}>
                            Resend OTP in {timerRegister}s
                          </small>
                        )}
                      </div>
                    )}
                  </div>
                )}

              {isOtpVerifiedRegister && (
                <div className="customer-otp-dotted-box text-center">
                  <button
                    type="button"
                    className="btn btn-success w-100 mt-3"
                    disabled
                  >
                    OTP Verified ✅
                  </button>
                </div>
              )}

              {isOtpSentRegister &&
                isOtpExpiredRegister &&
                !isOtpVerifiedRegister && (
                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSendRegisterOtp}
                    >
                      Resend OTP
                    </button>
                  </div>
                )}

              <div className="customer-input-group">
                <Form.Control
                  type="email"
                  placeholder=" "
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Invalid email address",
                    },
                  })}
                  className={classNames({ "is-invalid": errors?.email })}
                />
                <label>Email*</label>
                {errors?.email && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.email.message}
                  </span>
                )}
              </div>

              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  maxLength={12}
                  {...register("adhar_no", {
                    required: "Aadhar Card Number is required",
                    pattern: {
                      value: /^[0-9]{12}$/,
                      message: "Enter valid 12 digit Aadhar",
                    },
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 12);
                    // Cookies.remove("aadhaar_ref_id");

                    setAadharOtpError("");
                  }}
                  className={classNames({ "is-invalid": errors?.adhar_no })}
                  // disabled={isAadharOtpVerified}
                  disabled={isAadharLocked}
                />

                <label>Aadhar Number*</label>

                {errors?.adhar_no && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.adhar_no.message}
                  </span>
                )}
              </div>

              {isAadharOtpSent && !isAadharOtpVerified && (
                <button
                  type="button"
                  className="btn btn-link p-0 mt-1"
                  onClick={() => {
                    setIsAadharLocked(false);

                    setValue("adhar_no", "");

                    setIsAadharOtpSent(false);
                    setIsAadharOtpVerified(false);

                    setAadharOtp(["", "", "", "", "", ""]);

                    setAadharOtpTimer(600);
                    setIsAadharOtpExpired(false);

                    setAadharOtpError("");

                    Cookies.remove("aadhaar_ref_id");
                  }}
                >
                  Change Aadhaar Number
                </button>
              )}

              {/* Send OTP Button */}
              {!isAadharOtpSent && !isAadharOtpVerified && (
                <button
                  type="button"
                  className="btn btn-outline-primary w-100 mt-2"
                  onClick={handleSendAadharOtp}
                  disabled={loadingAadharSendOtp}
                >
                  {loadingAadharSendOtp ? "Sending..." : "Send Aadhaar OTP"}
                </button>
              )}
              {/* {aadharOtpError && (
                <div className="text-danger text-center mt-2">
                  {aadharOtpError}
                </div>
              )} */}

              {/* Aadhaar Error Message */}
              {aadharOtpError && !isAadharOtpSent && (
                <div className="text-danger mt-2 text-center">
                  {aadharOtpError}
                </div>
              )}

              {/* OTP Box */}
              {isAadharOtpSent && !isAadharOtpVerified && (
                <div className="customer-otp-dotted-box">
                  <label className="customer-otp-label">
                    Enter Aadhaar OTP
                  </label>

                  <div className="customer-otp-slots">
                    {aadharOtp.map((digit, index) => (
                      <div key={index} className="customer-otp-slot">
                        <input
                          id={`otp-aadhar-${index}`}
                          type="tel"
                          inputMode="numeric"
                          maxLength="1"
                          value={digit}
                          className="customer-otp-input"
                          onChange={(e) =>
                            handleAadharOtpChange(e.target.value, index)
                          }
                          onKeyDown={(e) => handleAadharOtpKeyDown(e, index)}
                        />
                        <hr className="customer-otp-line" />
                      </div>
                    ))}
                  </div>

                  {aadharOtpError && (
                    <div className="text-danger text-center mt-2">
                      {aadharOtpError}
                    </div>
                  )}

                  <button
                    type="button"
                    className="btn btn-success w-100 mt-3"
                    onClick={handleVerifyAadharOtp}
                    disabled={loadingAadharVerifyOtp}
                  >
                    {loadingAadharVerifyOtp
                      ? "Verifying..."
                      : "Verify Aadhaar OTP"}
                  </button>

                  {!isAadharOtpExpired ? (
                    <div className="text-center mt-2">
                      <small className="text-muted">
                        Resend Aadhaar OTP in {formatTimer(aadharOtpTimer)}
                      </small>
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-link w-100 mt-2"
                      onClick={async () => {
                        Cookies.remove("aadhaar_ref_id"); // remove old req_id

                        setAadharOtp(["", "", "", "", "", ""]);
                        setAadharOtpError("");
                        setIsAadharOtpExpired(false);
                        setAadharOtpTimer(600);

                        await handleSendAadharOtp(); // sends OTP and stores new req_id
                      }}
                    >
                      Resend Aadhaar OTP
                    </button>
                  )}
                </div>
              )}

              {/* Verified Message */}
              {isAadharOtpVerified && (
                <div className="customer-otp-dotted-box text-center">
                  <button
                    type="button"
                    className="btn btn-success w-100"
                    disabled
                  >
                    Aadhaar OTP Verified ✅
                  </button>
                </div>
              )}

              <div className="customer-input-group">
                <Form.Control
                  type="file"
                  accept=".jpg,.jpeg,.png"
                  {...register("profile_pic", {
                    required: "Profile picture is required",
                    validate: (value) => {
                      if (!value || !value[0]) return true;
                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                      ];
                      if (!allowedTypes.includes(value[0].type)) {
                        return "Only JPG, JPEG, PNG files are allowed";
                      }
                      return true;
                    },
                  })}
                  className={classNames({ "is-invalid": errors?.profile_pic })}
                />
                <label className="static-label">Profile Photo*</label>
                {errors?.profile_pic && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.profile_pic.message}
                  </span>
                )}
              </div>

              {profilePicFile && profilePicFile.length > 0 && (
                <div className="image-preview-container my-4">
                  <img
                    src={URL.createObjectURL(profilePicFile[0])}
                    alt="Profile Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "50%",
                      border: "1px solid #ddd",
                    }}
                  />
                </div>
              )}

              <div className="customer-input-group">
                <Controller
                  name="state_id"
                  control={control}
                  rules={{ required: "State is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={states}
                      styles={selectStyles}
                      classNamePrefix="react-select"
                      placeholder=""
                      onChange={handleStateChange}
                    />
                  )}
                />
                <label className="floating-label">State*</label>
                {errors?.state_id && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.state_id.message}
                  </span>
                )}
              </div>

              <div className="customer-input-group">
                <Controller
                  name="district_id"
                  control={control}
                  rules={{ required: "District is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={districts}
                      styles={selectStyles}
                      placeholder=""
                      isDisabled={!selectedState}
                      onChange={(selectedOption) =>
                        field.onChange(selectedOption)
                      }
                    />
                  )}
                />
                <label className="floating-label">District*</label>
                {errors?.district_id && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.district_id.message}
                  </span>
                )}
              </div>

              <div className="customer-input-group">
                <Controller
                  name="taluqa_id"
                  control={control}
                  rules={{ required: "Taluka is required" }}
                  render={({ field }) => (
                    <Select
                      {...field}
                      options={talukas}
                      styles={selectStyles}
                      placeholder=""
                      isDisabled={!selectedDistrict}
                      onChange={(selectedOption) =>
                        field.onChange(selectedOption)
                      }
                    />
                  )}
                />
                <label className="floating-label">Taluka*</label>

                {errors?.taluqa_id && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.taluqa_id.message}
                  </span>
                )}
              </div>

              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  {...register("area", {
                    required: "Area is required",
                    pattern: {
                      value: /^[A-Za-z0-9\s,.-]+$/,
                      message: "Enter valid area name",
                    },
                  })}
                  onChange={(e) => {
                    const value = e.target.value.replace(
                      /[^A-Za-z0-9\s,.-]/g,
                      "",
                    );
                    e.target.value = value;
                  }}
                  className={classNames({ "is-invalid": errors?.area })}
                />

                {errors?.area && (
                  <span className="invalid-feedback d-block mb-4">
                    {errors.area.message}
                  </span>
                )}

                <label>Area*</label>
              </div>

              <Form.Group className="customer-input-group">
                <Form.Control {...register("lat")} readOnly />
                <label className="static-label">Latitude</label>
              </Form.Group>

              <Form.Group className="customer-input-group">
                <Form.Control {...register("long")} readOnly />
                <label className="static-label">Longitude</label>
              </Form.Group>

              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  ref={searchInputRef}
                  className="mb-2"
                />
                <label>Search Location</label>
              </div>

              <div
                ref={mapRef}
                style={{
                  width: "100%",
                  height: "300px",
                  borderRadius: "10px",
                  marginTop: "10px",
                }}
              />
            </div>
          </div>
        )}

        <div className="customer-footer-actions">
          <div className="footer-content-block">
            {/* <Common_Login_Button
              text={isRegistering ? "Register" : "Login"}
              disabled={isRegistering && !isOtpVerifiedRegister}
            /> */}
            <Common_Login_Button
              text={
                isRegistering
                  ? loadingRegister
                    ? "Registering..."
                    : "Register"
                  : loadingLogin
                  ? "Logging in..."
                  : "Login"
              }
              disabled={
                isRegistering
                  ? loadingRegister || !isOtpVerifiedRegister
                  : loadingLogin
              }
            />

            <div className="customer-toggle-footer">
              <span className="acc-text">
                {isRegistering
                  ? "You have an account?"
                  : "Don't have an account?"}
              </span>
              <button
                type="button"
                className="customer-toggle-link"
                onClick={() => {
                  setIsRegistering(!isRegistering);

                  // Mobile OTP Reset
                  setRegisterOtp(["", "", "", "", "", ""]);
                  setIsOtpSentRegister(false);
                  setIsOtpVerifiedRegister(false);
                  setIsOtpExpiredRegister(false);

                  setLoginOtpArray(["", "", "", "", "", ""]);
                  setIsOtpSentLogin(false);
                  setIsOtpVerifiedLogin(false);
                  setIsOtpExpiredLogin(false);

                  // Aadhaar Reset
                  setIsAadharOtpSent(false);
                  setIsAadharOtpVerified(false);
                  setAadharOtp(["", "", "", "", "", ""]);
                  setAadharOtpTimer(600);
                  setIsAadharOtpExpired(false);
                  setAadharOtpError("");
                  setIsAadharLocked(false);

                  Cookies.remove("aadhaar_ref_id");
                }}
              >
                {isRegistering ? "Login Now" : "Create Account"}
              </button>
            </div>
          </div>
        </div>
      </Form>

      <Account_Created_Modal
        showAccountModal={showAccountModal}
        handleAccountModalClose={() => setShowAccountModal(false)}
        text={modalText}
      />
      <Login_Modal
        showLoginModal={showLoginModal}
        handleLoginModalClose={() => setShowLoginModal(false)}
      />
    </div>
  );
};

export default Customer_Login;
